// This is testing
// export const FIREBASE_CONFIG = {
//   apiKey: "AIzaSyB2HtFeY9XBq3EJFiGLM1c0BGeaa5rvi-k",
//   authDomain: "praxis-6b6a8.firebaseapp.com",
//   databaseURL: "https://praxis-6b6a8-default-rtdb.firebaseio.com",
//   projectId: "praxis-6b6a8",
//   storageBucket: "praxis-6b6a8.appspot.com",
//   messagingSenderId: "516717977820",
//   appId: "1:516717977820:web:cbd19e9a8723d82a81d419",
//   measurementId: "G-ME13MESMLC"
// };

// This is prod
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAepRszxLOdgIyKInpJbvCtxzqRbvAOImg",
  authDomain: "fynedental-apps.firebaseapp.com",
  databaseURL: "https://fynedental-apps-default-rtdb.firebaseio.com",
  projectId: "fynedental-apps",
  storageBucket: "fynedental-apps.firebasestorage.app",
  messagingSenderId: "769021450065",
  appId: "1:769021450065:web:e02200fb090bce3cb7a570",
  measurementId: "G-C4R5TEZVH1"
};

export function getProvisionedAppId(): string {
  return "dentwyze";
}